import React from "react";
import "./CustomModal.scss";

interface ModalProps {
  show: boolean;
  showfooter?: boolean;
  onClose?: () => void;
  children: React.ReactNode;
}

const CustomModal: React.FC<ModalProps> = ({ show,showfooter, onClose, children }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-body">{children}</div>
        {showfooter && <div className="modal-footer">
          <button onClick={onClose}>Close</button>
        </div>}
      </div>
    </div>
  );
};

export default CustomModal;